const OFFSET = 10;

export default () => ({
  offset: 0,

  init() {},

  //sets the tooltip offset if it would overflow the viewport
  position() {
    const contentPos = this.$el
      .querySelector('[tooltip-content]')
      .getBoundingClientRect();

    if (contentPos.left < OFFSET) {
      this.offset = Math.abs(contentPos.left) + OFFSET;
    }
    if (
      document.documentElement.clientWidth -
        (contentPos.left + contentPos.width) <
      OFFSET
    ) {
      this.offset =
        document.documentElement.clientWidth -
        (contentPos.left + contentPos.width) -
        OFFSET;
    }
  },
});
